import type { Sampling } from 'src/shared/types/sampling';

/**
 * Derives the unique cloak strings to show as filter tabs on the Samples tab.
 *
 * Only suppliers attached to at least one visible (non-archived) sampling are
 * included — samplings without a cloak are skipped so we never render a filter
 * that can't match any rows. Sorted alphabetically (case-insensitive).
 */
const getSamplingSupplierCloaks = (
  samplings: Sampling[] | undefined
): string[] => {
  const seen = new Set<string>();

  (samplings || [])
    .filter((sampling) => !sampling.archived)
    .forEach((sampling) => {
      if (sampling.cloak) seen.add(sampling.cloak);
    });

  return Array.from(seen).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
};

export default getSamplingSupplierCloaks;
